function toggleMenu(e) {
    // console.log(e);
    if ($(this).hasClass('menu-active')) {
        // $('.parent-sub').removeClass('menu-active');
    } else {
        // $('.parent-sub').removeClass('menu-active');
        $('.show-sub-menu').removeClass('show-sub-menu');
        // $(this).addClass('menu-active');
    }

    const subMenu = $(this).find('.sub-menu');
    if (subMenu.length > 0) {
        subMenu.toggleClass('show-sub-menu');
        if ($( window ).width() >= 993){
            // This adjust the position of mega menu to not fall off screen
            let subMenuSpacingFromleftWindow = subMenu.offset().left;
            let subMenuTotalWidth = subMenu.outerWidth();
            let totalWidth = subMenuSpacingFromleftWindow + subMenuTotalWidth;

            // console.log('spacing from left' + subMenuSpacingFromleftWindow);
            // console.log('menu width' + subMenuTotalWidth);
            // console.log($(window).width());
            // console.log(totalWidth + ' | ' + $(window).width());

            if (totalWidth > $(window).width()) {
                var offsetX = $(window).width() - ((totalWidth) + 10);
                // console.log('offset x ' + offsetX)
                if($(window).width() > 1800){
                    subMenu.css('transform', 'translateX(' + offsetX + 'px) translateX(-10%)');
                }else{
                    subMenu.css('transform', 'translateX(' + offsetX + 'px)');
                }
            }else{
                // var offsetX = '0'; // '-100' if you wanna go little extra
                // subMenu.css('transform', 'translateX(' + offsetX + 'px)');
            }
        }
        else{
            if ($(this).hasClass('js-open')) {
                $(this).find('.sub-menu').removeClass('show-sub-menu');
                $('.rotate').removeClass('rotate');
                $(this).removeClass('js-open');

            } else {
                $(this).addClass('js-open');
                $('.rotate').removeClass('rotate');
                $(this).find('.dropdown-arrow').addClass('rotate');
            }
        }
    }
}

if ($( window ).width() >= 993)
{
    $(".parent-sub").click(toggleMenu);
    $(".parent-sub").keydown(function (ev) {
        if (ev.which == 13) {
            toggleMenu.call(this, ev);
        }
    });
}else{
    $(".parent-sub").click(toggleMenu);
}

$('.parent-sub').mouseleave(function() {
    // Add your code for when hovering off of '.parent-sub'
    // $('.sub-menu').css('transform', 'translateX(0px)');
});


// console.log($(window).width());

$('a[href="#"]').on('click', function(e) {
    e.preventDefault();
});

//removes dropdown menu active class when clicking outside of element
$('body').on('click', function(e) {
    var dropdownMenu = $('.show-sub-menu,.parent-sub,.js-search');
    if(dropdownMenu !== e.target && !dropdownMenu.has(e.target).length){


        $('.sub-menu').removeClass('show-sub-menu');
        // $('.parent-sub').removeClass('menu-active');
        $('.js-search').removeClass('is-active');
        $('.rotate').removeClass('rotate');
        $(".site-navigation").removeClass('opacity-0');
        $('.submit-search').removeClass('enable');

    }
});

(function($) {
    // Toggle collapse on submenu
    $('#navbarToggle').on('click', function() {
        var primaryNavigation = $('.site-navigation');
        $this = $(this);

        $('.js-search').removeClass('is-active');
        $(".site-navigation").removeClass('opacity-0');
        $('.submit-search').removeClass('enable');

        // Dropdown toggle setup
        if(primaryNavigation.hasClass('mobile-show')) {
            primaryNavigation.removeClass('mobile-show');
            $('body').removeClass('no-scroll');
            $this.addClass('collapsed');
            $this.attr('aria-expanded', 'false');

        } else {
            primaryNavigation.addClass('mobile-show');
            $('body').addClass('no-scroll');
            $this.removeClass('collapsed');
            $this.attr('aria-expanded', 'true');
        }
    });
}(jQuery));

$(document).ready(function() {
    $('.submit-search').click(function(event) {
        var $this = $(this);
        $(".site-navigation").addClass('opacity-0');
        $('.sub-menu').removeClass('show-sub-menu');
        // $('.parent-sub').removeClass('menu-active');
        $('.js-search').addClass('is-active');
        if ($(this).hasClass('enable')) {
        } else {
            event.preventDefault(); // Prevent form submission
            $(this).addClass('enable'); // Add the class 'enable'
        }
        var primaryNavigation = $('.site-navigation');
        primaryNavigation.removeClass('mobile-show');
        $('body').removeClass('no-scroll');
        $this.addClass('collapsed');
        $this.attr('aria-expanded', 'false');
    });
});


$(document).keyup(function(e) {
    if (e.keyCode == 27) { // escape key maps to keycode `27`
        // console.log('esc');
        if($('.sub-menu').hasClass('show-sub-menu')) {
            $('.sub-menu').removeClass('show-sub-menu');
        }
        if($('.js-search').hasClass('is-active')) {
            $('.js-search').removeClass('is-active');
            $(".site-navigation").removeClass('opacity-0');
            $('.submit-search').removeClass('enable');
        }
    }
});